module.exports = __webpack_public_path__ + "files/6052778696d10b965ef84db903d34a8a.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/favicon-16x16.png
// module id = 523
// module chunks = 60